Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call( this );
  this.element.classList.add('flickity-resize');
};

$(document).ready(function() {
  // Add smooth scrolling to all links
  $('a').on('click', function() {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== '') {
      if($('body').hasClass('show-menu')) {
        $('body').removeClass('show-menu');
      }

      if($('.sd-header .mobile-burger-icon').hasClass('show-menu')) {
        $('.sd-header .mobile-burger-icon').removeClass('show-menu');
      }
      // Prevent default anchor click behavior
      // event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top,
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
  
  headerScripts();
  featuredGallerySlider();
  customTestomonialsSlider();
  formScripts();
  formDropdownAdditions();
});

$(window).on('resize', function () {
  $('.sd-custom-featured-gallery-section .description-wrp-inner, .sd-custom-featured-gallery-section .images-wrp, .sd-custom-testimonials-section .testimonial-wrp'
  ).flickity('resize');

  $('.sd-mobile-menu .menu-wrp').css('padding-top', $('.sd-header').outerHeight());
  $('main > .shopify-section:nth-child(2)').css('margin-top', $('.sd-header').outerHeight());
});

$(window).on('load', function () {
  $('.sd-custom-featured-gallery-section .description-wrp-inner, .sd-custom-featured-gallery-section .images-wrp, .sd-custom-testimonials-section .testimonial-wrp'
  ).flickity('resize');
});

function formScripts() {
  $('.sd-select2-wrapper').each(function() {
    $(this).find('.sd-select-control').select2({
      dropdownParent: $(this),
    });
  });
}

function headerScripts() {
  // toggle class on hamburger icon click
  $('.sd-header .mobile-burger-icon').click(function () {
    $('body, .sd-header .mobile-burger-icon').toggleClass('show-menu');
  });

  if ($('.sd-header').hasClass('enable-scroll-up')) {
    var lastScrollTop = 0, delta = 15;
    var bannerHeight = $('.sd-header').outerHeight();
    $(window).scroll(function(){
      var st = $(this).scrollTop();

      if(Math.abs(lastScrollTop - st) <= delta)
        return;
      if ((st > lastScrollTop) && (lastScrollTop>0)) {
            // downscroll code
            $('.sd-header').css('top', (bannerHeight - (bannerHeight *2)));
      } else {
        // upscroll code
        $('.sd-header').css('top','0px');
      }
      lastScrollTop = st;
    });

    $('.sd-mobile-menu .menu-wrp').css('padding-top', bannerHeight);
    $('main > .shopify-section:nth-child(2)').css('margin-top', bannerHeight);
  }
}

function featuredGallerySlider() {
  var cellAlignValue = '';

  if (matchMedia('screen and (max-width: 768px)').matches) {
    cellAlignValue = 'center';
  } else {
    cellAlignValue = 'left';
  }

  $('.sd-custom-featured-gallery-section .description-wrp-inner').flickity({
    asNavFor: '.sd-custom-featured-gallery-section .images-wrp',
    pageDots: false,
    wrapAround: true,
    adaptiveHeight: true,
    cellAlign: cellAlignValue
  });

  $('.sd-custom-featured-gallery-section .images-wrp').flickity({
    asNavFor: '.sd-custom-featured-gallery-section .description-wrp-inner',
    prevNextButtons: false,
    pageDots: true,
    wrapAround: true,
    cellAlign: cellAlignValue 
  });

  $('.sd-custom-featured-gallery-section').each(function() {
    $(this).find('.flickity-button').appendTo($(this).find('.flickity-btns'));
  });

  // $('.sd-custom-featured-gallery-section .description-item-inner').each(function() {
  //   console.log($(this).outerHeight());
  //   $(this).parents('.flickity-viewport').css('height', $(this).outerHeight());
  // });
}

function customTestomonialsSlider() {
  $('.sd-custom-testimonials-section .testimonial-wrp').flickity({
    prevNextButtons: true,
    pageDots: true,
    wrapAround: true,
    cellAlign: 'center'
  });

  $('.sd-custom-testimonials-section').each(function() {
    $(this).find('.flickity-button').appendTo($(this).find('.flickity-btns'));
  });
}

function formDropdownAdditions() {
  $('.sd-at-watf-section .qualifications-item').each(function() {
    $(this).find('.button-wrap > a').click(function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $("#art-therapy-contact").offset().top
      }, 2000);
      $('.sd-select-control').val($(this).attr('href')).trigger('change');
    });
  });
}